import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IFormFieldConfig } from '../../models/formConfig.model';
import { IFormFieldHint } from '../../models/formConfig.model';

@Component({
  standalone: true,
  selector: 'pm-form-field-hint',
  imports: [],
  templateUrl: './pm-form-field-hint.component.html',
  styleUrl: './pm-form-field-hint.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PmFormFieldHintComponent {
  @Input() formField?: IFormFieldConfig;
  @Input() ctrl?: FormControl;
  @Input() data?: IFormFieldHint;

  get hint() {
    if (this.data) return this.data;
    if ((this.ctrl as any)?.hint) return (this.ctrl as any)?.hint();
    return null;
  }
}
